function activateShogun(mutationList, observer) {
    let productHandleOnTech = ontech.state.get(State.Settings.PRODUCT_HANDLE);
    for (const mutation of mutationList) {
        if (mutation.target.className.includes('shg-gallery-thumb-list') && !registeredItem) {
            $('.shg-gallery-thumb-image').on('click', function (event) {
                sendAnalytics("view_product_photo",{
                    [DataModel.PRODUCT_TYPE]: "product",
                    [DataModel.PRODUCT_CATEGORY]: "Product",
                    [DataModel.PRODUCT_ID]: [window.__shgProducts[productHandleOnTech].id],
                    [DataModel.PRODUCT_NAME]: [window.__shgProducts[productHandleOnTech].title],
                    [DataModel.PRODUCT_BRAND]: [window.__shgProducts[productHandleOnTech].vendor],
                    [DataModel.PRODUCT_PRICE]: [window.__shgProducts[productHandleOnTech].price / 100.0],
                    [DataModel.PRODUCT_SKU]: [window.__shgProducts[productHandleOnTech].variants[0].sku],
                    [DataModel.VARIANT_ID]: [window.__shgProducts[productHandleOnTech].variants[0].id],
                    [DataModel.MEMBERSHIP_EXISTING]: ontech.state.get(State.Membership.IS_MEMBER),
                    [DataModel.PHOTO_NAME]: [event.delegateTarget.src.split('/').pop()],
                    [DataModel.PAGE_TYPE]: "product_detail_page"
                })
            })
            registeredItem = true;
            break;
        } else if (registeredItem) {
            break;
        }
    }
}
